import { Outlet } from "react-router-dom";
import HomeNavigation from "./HomeNavigation";
import HomeFooter from "./HomeFooter";
import "./foundation.css";

export default function ModernLayout() {
  return (
    <div className="sn-ui">
      <a href="#sn-main" className="sn-skip">Skip to content</a>
      <HomeNavigation />
      <main id="sn-main" tabIndex="-1"><Outlet /></main>
      <HomeFooter />
    </div>
  );
}
